import {
  Component,
  OnInit,
  ViewChild,
  ViewChildren,
  QueryList,
  HostListener
} from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';
import { SelectItem, LazyLoadEvent } from 'primeng/api';
import { MultiSelect } from 'primeng/multiselect';
import { Table } from 'primeng/table';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { TabName } from '../../../models/_enum-collections';
import { EngagementEditInput } from '../../../models/engagement-edit-input.model';
import { EngagementSearchAndFilterInput } from '../../../models/engagement-search-and-filter-input.model';
import { L1InternalStatus } from '../../../models/l1-internal-status.model';
import { L2InternalStatus } from '../../../models/l2-internal-status.model';
import { PartnerInput } from '../../../models/partner-input.model';
import { PartnerType } from '../../../models/partner-type.model';
import { PoeStatus } from '../../../models/poe-status.model';
import { TaskOwner } from '../../../models/task-owner.model';
import { AppConstants } from '../../common/app-constants';
import { CommonSharedModule } from '../../common/shared.module';
import { EditComponent } from '../../home/edit/edit.component';
import { LocalStorageService } from '../../services/local-storage-service';
import { OsmosisEditService } from '../../services/osmosis-edit.service';
import { OsmosisService } from '../../services/osmosis.service';
import { EditIncentiveComponent } from '../edit-incentive/edit-incentive.component';

@Component({
  selector: 'app-all-incentives',
  templateUrl: './all-incentives.component.html',
  styleUrls: ['./all-incentives.component.scss'],
  standalone: true,
  imports: [CommonSharedModule, EditIncentiveComponent]
})
export class AllIncentivesComponent implements OnInit {
  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;
  @ViewChild('dt', { static: false }) dt!: Table;
  @ViewChildren('tak') components!: QueryList<MultiSelect>;

  constructor(
    private osm: OsmosisService,
    private router: Router,
    private osmEdit: OsmosisEditService,
    public localStorage: LocalStorageService
  ) {}

  get isProdEnvironment(): boolean {
    return environment.isProdEnvironment;
  }

  taskOwnerDrpdwn!: TaskOwner[];
  partnertypes!: PartnerType[];
  ftaskOwnerDrpdwn: SelectItem[] = [];
  partnerTypeDrpdwn: SelectItem[] = [];
  l1InternalStatus1!: L1InternalStatus[];
  fl1InternalStatusDrpdwn: SelectItem[] = [];
  rows = [];
  l2InternalStatus1Drpdwn: SelectItem[] = [];
  l2InternalStatus1!: L2InternalStatus[];
  poeStatus!: PoeStatus[];
  poeStatusDrpdwn: SelectItem[] = [];
  incentiveStatusDrpdwn: SelectItem[] = [];
  pmos!: PartnerInput[];
  partnerInputs: PartnerInput[] = [];
  pmo: PartnerInput = {};

  scrollableCols!: any[];
  frozenCols!: any[];
  globalFilterCols!: any[];
  excelLoading = false;

  currentPageInfo!: string;
  loadingIcon = 'fa-circle-o-notch';
  totalRecords!: number;
  tblPageNumber!: number;
  recPerPage!: number;
  display!: boolean;
  loading = false;
  dataViewRecsPerPage!: number;
  pageLinksPerPage!: number;
  emptyRecordMsg!: string;

  loadEditComponent = false;
  editNav = false;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  showFullscreen = false;
  engagementEditInput!: EngagementEditInput;
  searchAndFilterInput!: EngagementSearchAndFilterInput;
  currentSearchSubscription!: Subscription;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  delayedLoadSearchContent!: Function;

  static save(data: Blob, name: string) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(data);
    a.href = url;
    const filename = name;
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }
  @HostListener('window:resize') onresize(): void {
    requestAnimationFrame(() => {
      const editEngagement = document
        ?.querySelector('#engagementEdit')
        ?.querySelector<HTMLElement>('[role="dialog"]');

      if (editEngagement) {
        editEngagement.style.width = '90%';
        editEngagement.style.height = '85%';
      }
    });
  }
  ngOnInit() {
    this.dataViewRecsPerPage = AppConstants.dataListRecsPerPage;
    this.pageLinksPerPage = AppConstants.dataListPagerLinks;
    this.emptyRecordMsg = AppConstants.emptyRecordMsg;

    this.display = false;
    this.loading = true;
    this.loadEditComponent = false;
    this.editNav = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();
    this.engagementEditInput = {
      showFullScreen: this.showFullscreen
    } as any;

    this.scrollableCols = [
      { field: 'taskOwner', header: 'Task Owner' },
      { field: 'l1InternalStatus', header: 'L1Internal tatus' },
      { field: 'poeStatus', header: 'POE Status' },
      { field: 'requestDate', header: 'Request Date' },
      { field: 'engagementSubType', header: 'Engagement Sub Type' },
      { field: 'partnerInputParnterName', header: 'PartnerInputPartnerName' },
      { field: 'partnerInputMPNId', header: 'Partner Input MPNID' },
      {
        field: 'partnerInputCustomerTPId',
        header: 'Partner Input Customer TPID'
      },
      {
        field: 'partnerInputCustomerTenantId',
        header: 'Partner Input Customer Tenant ID'
      },
      {
        field: 'partnerInputCustomerDomainName',
        header: 'Partner Input Customer Domain Name'
      },
      { field: 'requestID', header: 'Request ID' }
    ];

    this.frozenCols = [{ field: 'engagementKey', header: 'Engagement Key' }];

    this.globalFilterCols = [
      'engagementKey',
      'taskOwner',
      'l1InternalStatus',
      'poeStatus',
      'requestDate',
      'engagementSubType',
      'partnerInputPartnerName',
      'partnerInputMPNId',
      'partnerInputCustomerTPId',
      'partnerInputCustomerTenantId',
      'partnerInputCustomerDomainName',
      'requestID'
    ];

    this.delayedLoadSearchContent = _.debounce(this.loadSearchContent, 1000);
    this.resetFiltersAndLoad();
    this.getTaskOwnerList();
    this.getPartnerTypeList();
    this.getL1InternalStatusList();
    this.getL2InternalStatusList();
    this.getPoeStatus();
    this.getIncentiveStatus();
  }
  getPartnerTypeList() {
    this.osmEdit.getPartnerTypeDropDown().subscribe(PTList => {
      this.partnertypes = PTList;
      for (const item of this.partnertypes) {
        const partnerTypeDrpdwn: SelectItem = {
          label: item.partnerType,
          value: item.partnerType
        };
        this.partnerTypeDrpdwn.push(partnerTypeDrpdwn);
      }
    });
  }

  getTaskOwnerList() {
    this.osmEdit.getTaskOwnerDropDown().subscribe(PTList => {
      this.taskOwnerDrpdwn = PTList;
      for (const item of this.taskOwnerDrpdwn) {
        const ftaskOwnerDrpdwn: SelectItem = {
          label: item.taskOwner,
          value: item.taskOwner
        };
        this.ftaskOwnerDrpdwn.push(ftaskOwnerDrpdwn);
      }
    });
  }
  getL1InternalStatusList() {
    this.osmEdit.getL1InternalStatusDropDown().subscribe(PTList => {
      this.l1InternalStatus1 = PTList;
      for (const item of this.l1InternalStatus1) {
        const fl1InternalStatusDrpdwn: SelectItem = {
          label: item.l1internalStatus,
          value: item.l1internalStatus
        };
        this.fl1InternalStatusDrpdwn.push(fl1InternalStatusDrpdwn);
      }
    });
  }

  getL2InternalStatusList() {
    this.osmEdit.getL2InternalStatusDropDown().subscribe(PTList => {
      this.l2InternalStatus1 = PTList;
      for (const item of this.l2InternalStatus1) {
        const l2InternalStatus1Drpdwn: SelectItem = {
          label: item.l2internalStatus,
          value: item.l2internalStatus
        };
        this.l2InternalStatus1Drpdwn.push(l2InternalStatus1Drpdwn);
      }
    });
  }
  getIncentiveStatus() {
    this.incentiveStatusDrpdwn.push({
      label: 'Not Started',
      value: 'Not Started'
    });
    this.incentiveStatusDrpdwn.push({ label: 'Pending', value: 'Pending' });
    this.incentiveStatusDrpdwn.push({ label: 'Expired', value: 'Expired' });
    this.incentiveStatusDrpdwn.push({ label: 'Active', value: 'Active' });
    this.incentiveStatusDrpdwn.push({ label: 'Cancelled', value: 'Cancelled' });
  }

  getPoeStatus() {
    this.poeStatusDrpdwn.push({ label: 'Missing', value: 'Missing' });
    this.poeStatusDrpdwn.push({ label: 'In Review', value: 'In Review' });
    this.poeStatusDrpdwn.push({ label: 'Completed', value: 'Completed' });
    this.poeStatusDrpdwn.push({ label: 'Rejected', value: 'Rejected' });
    this.poeStatusDrpdwn.push({ label: 'N/A', value: 'N/A' });
  }

  editRequestDetails(id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.requestDetailId = id;
    this.engagementIdPassToChild = id;
    this.engagementEditInput.engagementId = id;
    this.engagementEditInput.isOptOutPartner = this.pmos.find(
      x => x.engagementKey === id
    )?.isOptOutPartner;
  }

  fillUser(id: string) {
    this.getByRequestDetails(id);
  }

  getByRequestDetails(tpId) {
    this.osm.getFactDataByRequestDetails(tpId).subscribe();
  }

  getUserList(): void {
    this.osm.getAllList().subscribe(serviceOutput => {
      this.pmos = serviceOutput;
    });
  }

  pageChange() {
    this.computeResultsCountText();
  }

  applyFilter(event) {
    this.totalRecords = event.filteredValue.length;
    this.computeResultsCountText();
  }

  computeResultsCountText() {
    if (this.totalRecords === 0) {
      this.currentPageInfo = 'No Record Found';
    } else {
      const currentStartCount =
        (this.searchAndFilterInput.page - 1) * this.dataViewRecsPerPage;
      const currentEndCount = currentStartCount + this.dataViewRecsPerPage;
      this.currentPageInfo =
        'Showing ' +
        (currentStartCount + 1) +
        ' - ' +
        (currentEndCount > this.totalRecords
          ? this.totalRecords
          : currentEndCount) +
        ' of ' +
        this.totalRecords +
        ' Records';
    }
  }

  export() {
    this.router.navigate(['/msai-download-csv']);
  }

  reset() {
    this.components['_results'].forEach(ds => {
      ds.value = null;
    });

    if (this.dt) {
      this.dt.filter('', 'taskOwner', 'in');
      this.dt.filter('', 'l1InternalStatus', 'in');
      this.dt.filter('', 'engagementType', 'in');
      this.dt.reset();
    }

    this.display = false;
    this.loading = true;
    this.resetFiltersAndLoad();
  }

  resetFiltersAndLoad() {
    this.searchAndFilterInput = new EngagementSearchAndFilterInput();
    this.searchAndFilterInput.pageSize = AppConstants.dataListRecsPerPage;
    this.searchAndFilterInput.page = 1;
    this.searchOrFilterEngagements();
  }

  refresh() {
    this.searchOrFilterEngagements();
  }

  redirectToPartner(partnerMpnId: string) {
    this.router.navigate(['/partner-dashboard'], {
      queryParams: {
        mpnId: partnerMpnId
      }
    });
  }
  downloadFile(data) {
    const blob = new Blob([data as any], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }

  save(data: Blob) {
    const a = document.createElement('a');
    document.body.appendChild(a);
    const url = window.URL.createObjectURL(data);
    a.href = url;
    const filename = 'download';
    a.download = filename;
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  }
  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  clearSearchText() {
    this.searchAndFilterInput.searchString = '';
    this.searchOrFilterEngagements();
  }

  searchOrFilterEngagements() {
    this.searchAndFilterInput.page = 1;
    if (this.dt) {
      this.dt.first = this.searchAndFilterInput.page;
    }
    this.delayedLoadSearchContent();
  }

  loadSearchContent(event?: LazyLoadEvent) {
    this.loading = true;
    this.searchAndFilterInput.computeFilterListParams();
    if (this.currentSearchSubscription) {
      this.currentSearchSubscription.unsubscribe();
    }
    if (event != null) {
      this.searchAndFilterInput.page =
        (event.first ?? 0) == 0
          ? 1
          : (event.first ?? 0) / this.dataViewRecsPerPage + 1;
      if (event.sortField) {
        this.searchAndFilterInput.sortField = event.sortField;
        this.searchAndFilterInput.sortOrderDescending =
          event.sortOrder == 1 ? false : true;
      }
    }
    this.searchAndFilterInput.tabName = TabName.AllActivity;
    this.currentSearchSubscription = this.osm
      .searchEngagementsForAdvoicerIncentives(this.searchAndFilterInput)
      .subscribe(
        result => {
          this.pmos = result.results;
          this.totalRecords = result.rowCount;
          this.computeResultsCountText();
          this.loading = false;
        },
        () => {
          this.pmos = [];
          this.totalRecords = 0;
          this.loading = false;
          this.computeResultsCountText();
        }
      );
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
  }
}
